module.exports = __webpack_public_path__ + "media/140.cad572e0.mp3";